import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { KbEntry } from "@shared/models/kb-entry"
import FindDoc from "cc-frontend/helpers/find-doc"
import HasManyAltogether from "cc-frontend/helpers/has-many-altogether"
import type EmberStore from "cc-frontend/services/ember-store"
import { use } from "ember-could-get-used-to-this"

interface Signature {
  Element: HTMLDivElement
  Args: {
    // popularTopicsId: string
  }
}

export default class KbPopularTopics extends Component<Signature> {
  @service("ember-store") declare store: EmberStore

  popularTopicsId = "6ANjZV08tUkeaaU0o2wQqS"

  @use popularTopicsEntry = new FindDoc(() => ["kb-entry", this.popularTopicsId])

  @use popularTopics = new HasManyAltogether<KbEntry>(() => [
    this.popularTopicsEntry.content,
    "children",
    "kb-entry",
  ])
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Kb::PopularTopics": typeof KbPopularTopics
  }
}
